export default function Services() {
  const items = [
    {
      title: "Visita al Bio Parque Puquén",
      text: "Acceso al Bio Parque Puquén en los molles.",
    },
        {
      title: "Caminatas",
      text: "Camina por la playa.",
    },
    {
      title: "Cabalgatas",
      text: "Cabalgatas a la entrada de los Molles.",
    },
    {
      title: "Surf y buceo",
      text: "Escuelas de surf y buceo diaras.",
    },
    {
      title: "Restaurant y cafetería",
      text: "Diversos tipos de restaurantes al borde del mar.",
    },

    {
      title: "Juegos recreativos",
      text: "Lota y juegos infantiles.",
    },
  ];

  return (
    <section
        
      className="py-20 bg-gradient-to-b from-white via-sky-50 to-white"
    >
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
          ¿Qué hago?
        </h2>

        <div className="mt-8 grid md:grid-cols-3 gap-6">
          {items.map((i) => (
            <div
              key={i.title}
              className="p-6 rounded-2xl border bg-white shadow-sm hover:shadow-md transition"
            >
              <h3 className="font-semibold text-gray-800">{i.title}</h3>
              <p className="text-gray-600 mt-2">{i.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
